import { useCallback, useRef } from "react";

/**
 * Hook personalizado para implementar debounce em funções
 * @param callback - Função a ser executada após o delay
 * @param delay - Tempo de delay em milissegundos
 * @returns Função debounced
 */
export const useDebounce = <T extends (...args: never[]) => void>(
  callback: T,
  delay: number
): ((...args: Parameters<T>) => void) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedCallback = useCallback(
    (...args: Parameters<T>) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  return debouncedCallback;
};
